import React from 'react';
import { Flex } from 'antd';
import { usePlatformConfig } from 'hooks/PlatformContext';
import './index.scss';
import { useLanguage } from 'hooks/Languages/useLanguage';

const RightItems = () => {
  const { translate } = useLanguage();
  const plateText = usePlatformConfig();

  return (
    <Flex vertical className="right-items-container">
      {/* <div className="top-auth-items">
        <span className="large-text white-text font-weight-bold">
          {plateText?.appName}
        </span>
      </div> */}
      <Flex
        align="center"
        justify="center"
        className="bottom-auth-items"
        vertical
      >
        <div className="bottom-auth-items__message">
          <span className="large-text">
            {translate(plateText?.welcomeMessage)}
          </span>
        </div>
      </Flex>
    </Flex>
  );
};

export default RightItems;
